/**
 * Zoom and scale constants for the image preview modal
 */

/** Minimum scale (no zoom) */
export const MIN_SCALE = 1;

/** Maximum scale (5x zoom) */
export const MAX_SCALE = 5;

/** Scale increment/decrement for each zoom action */
export const ZOOM_STEP = 0.5;

